import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem
      primaryText='Manage'
      key='manage'
      value={`/events/session-sales/${resource.session_sale_id}/waitlist/${resource.id}/show`}
    />
  ]
}

export default buildMenuItems
